const en = {
    music: 'Music',
    findMusic: 'FIND MUSIC',
    myMusic: 'MY MUSIC',
    friend: 'FRIEND',
    musician: 'MUSICIAN',
    download: 'Download',
    date: 'DATE',
    lang: 'LANGUAGE',
    text: 'TEXT',
    theme: 'Theme',
    content: 'Content',
    autoGenerate: 'Automatically generate',
    chooseDate: 'please choose date',
    headerNewWindow: 'new Tab',
    baseRole: 'Common Role',
    functionalHR: 'Functional HR',
    systemName: 'Performance Manage',
    userManage: 'User Management',
    roleManage: 'Role management',
    userName: 'Username',
    roleName: 'Role Name',
    roleCode: 'Role Code',
    roleType: 'Role Type',
    typeId: 'Category ID',
    roleDetail: 'Role Details',
    roleOrder: 'Role Order',
    explain: 'Description',
    search: 'Query',
    reset: 'Reset',
    placeholderInput: 'please enter the content',
    placeholderSelect: 'please select the content',
    userId: 'userID',
    employeeNumber: 'Empl ID',
    chineseName: 'Chinese Name',
    AuthorizedRole: 'Authorized Role',
    operation: 'Operation',
    templateName: 'Template Name',
    authorizedMenu: 'Authorized Menu',
    templateDescription: 'Template Description',
    roleAuthorization: 'Role Authorization',
    permAuthorization: 'Permission Authorization',
    permissionCode: 'permission Code',
    permissionName: 'permission Name',
    permissionDetail: 'permission details',
    permissionID: 'permission ID',
    cancel: 'Cancel',
    confirm: 'Confirm',
    add: 'Add',
    edit: 'Edit',
    del: 'Delete',
    exit: 'Return',
    exit2: 'Exit',
    save: 'Save',
    submit: 'Submit',
    description: 'Description',
    authorization: 'Authorization',
    dataAuthorization: 'Authorization of the data',
    input: 'Please fill out',
    select: 'Please select',
    resourceManage: 'Resource Management',
    resourceName: 'Resource Name',
    resourceCode: 'Resource Code',
    resourceOrder: 'Resource Order',
    resourcePath: 'Resource Path',
    parentID: 'Parent ID',
    resourceType: 'Resource Type',
    createDate: 'Created Date',
    updateDate: 'Updated Date',
    successMsg: 'Success',
    failMsg: 'Fail',
    addMsg: 'Add Success',
    editMsg: 'Edit Success',
    delMsg: 'Delete Success',
    addFailMsg: 'Add Fail',
    editFailMsg: 'Edit Fail',
    delFailMsg: 'Delete Fail',
    delConfirmMsg: 'Whether or not Delete this item',
    delConfirmTips: 'Delete this person?',
    delConfirmTips2: 'Are you sure to delete?',
    index: 'NO',
    code: 'Code',
    appliablePerson: 'Applicable Personnel',
    personType: 'Personnel Type',
    KPIfrequency: 'Default KPI assessment frequency',
    status: 'Status',
    state: 'State',
    indexConfig: 'Model Configuration',
    indexModel: 'Index Model',
    on: 'Enable',
    off: 'Deactivate',
    frequency: 'Frequency',
    personTypeConfig: 'Person Type',
    modelStandard: 'Model Standard',
    indicatorlibrary: 'Indicator Of Library',
    compositeIndex: 'Combination Index',
    compositeIndicator: 'Combination Indicator',
    viewDetail: 'View Detail',
    modelName: 'Model Name',
    value: 'Value',
    clone: 'Copy',
    year: 'Year',
    targetValue: 'Target Value',
    evaluationObjectives: 'Evaluation Objectives',
    modelConfig: 'Model Config',
    type: 'Type',
    import: 'Import',
    downloadTemp: 'Download Template',
    export: 'Export',
    maintainTemp: 'Maintain Template',
    importTemp: 'Import Template',
    simplifyDescription: 'Simplify Description',
    traditionalDescription: 'Traditional Description',
    englishDescription: 'English Description',
    targetName: 'Indicator Name',
    kpiOrNodeWorkObjective: 'Kpi Or Node Work Objective',
    departmentKPI: 'Department KPI',
    businessOrWorkPlan: 'Business/Work Plan(Project)',
    unit: 'Unit',
    challenge: 'Challenge',
    budget: 'Budget',
    lowThanBudget: 'Under Budget',
    minLimit: 'Lower Limit',
    targetYear: 'Assessment Year',
    historyYear: 'History Annual',
    CopyYear: 'Copy Year',
    indicatorTypes: 'Indicator Type',
    indicatorClassification: 'Indicator Classification',
    indexClassification: 'Index Classification',
    indicatorDescrtion: 'Indicator Description',
    indicatorCode: 'Indicator Code',
    indexCode: 'Index Code',
    functionalPersonelSubclass: 'Functional Personnel Subclass',
    dataResource: 'Data Source',
    dataResource2: 'Data Source',
    calculationMethod: 'Calculation Method',
    calculationRule: 'Calculation Rules',
    whetherApplyTheDefaultModel: 'Is the Default Model Applicable',
    chooseIndexModel: 'Choose IndexModel',
    executiveIndicatorModel: 'Executive Indicator Model',
    executiveModelName: 'Executive Indicator Name',
    baseIndicator: 'Base Indicator',
    composeIndicator: 'Portfolio Indicator Name',
    time: 'Time',
    oper: 'Operation',
    effectDate: 'Effective Date',
    dbLineAssConfig: 'Weight setting',
    close: 'close',
    returnInfo: 'return after 3 seconds',
    SaleAssessment: "Sales/Market (Assessment)",
    SaleComplaint: "Sales/Market (Complaint Handling)",
    ExecutiveAssessment: 'Executives(Assessment)',
    assessType: 'KPI/STI',
    assessMethod: 'Assessment Mode',
    funcType: 'Job Category',
    period: 'Period',
    period2: 'Period',
    assessmentFrequency: 'Appraisal Frequency',
    indicatorAttachmentDescr: 'Indicator to Statement',
    attachment: 'attachment',
    saleRevenuePersonnel: 'sale Revenue-personnel',
    personnelProfit: 'profit-personnel',
    tenThousand: 'ten thousand',
    personnelChanges: 'Person Changes',
    query: 'Query',
    maintain: 'Maintenance',
    assessYear: 'Annual',
    assessStartDate: 'assessStartDate',
    assessEndDate: 'assessEndDate',
    departmentNumber: 'departmentNumber',
    mainOrPartTime: 'Primary Job / Secondary Job',
    businessAssessPersonId: 'Level 1/2 Appraiser ID Of Business Reporting Line',
    businessAssessPersonName: 'Level 1/2 Appraiser Name Of Business Reporting Line',
    partTimeAssessIndDesc: 'Deputy post appraisal',
    weight: 'Weight',
    weighting: 'Weighting',
    entryDate: 'Hire Date',
    leaveDate: 'Dimission Date',
    transferDate: 'Date of change',
    maintenanceRecords: 'Maintenance Record',
    administrativeLine: 'Direct reporting line',
    businessLine: 'Dotted line',
    haveBusiness: 'Double line assess',
    mainAndPostWeight: 'Main and vice post weighting',
    subclass: 'Subclass',
    firstAssessor: 'Level 1 Appraiser',
    secondAppraiser: 'Level 2 Appraiser',
    dottedLineReporterOfAppraisee: 'Dotted line reporter of the appraisee',
    supervisorLineOfDdottedLineReporter: 'Line supervisor of the dotted line reporter',
    record: 'record',
    modifyPerson: 'Modified by',
    modifyTime: 'Modification time',
    queryFailed: 'Query failed',
    submittedSuccess: 'Submitted successfully',
    submittedFail: 'Submitted failed',
    editSuccess: 'Edit Successfully',
    editFail: 'Edit Successfully',
    savedSuccess: 'Saved successfully',
    savedFail: 'Save failed',
    newProcess: 'New in processing',
    noNeedProcess: 'No processing required',
    salaryType: 'Payroll Category',
    salaryTypeChangeDate: 'Salary Variation Date',
    sourceDeptName: 'Former Department',
    sourcePosttionName: 'Original Position',
    sourceLevel: 'Former employee level',
    targetNameNew: 'Target name',
    applicableCompany: 'applicable company',
    noData: 'No data',
    appraiseCategory: 'Appraisal category',
    assessmentCategory: 'Appraisal category',
    fillInActualValue: 'fill in actual value',
    actualValueOfSpecialPersonnel: 'Actual value of special personnel',
    targetManagement: 'Goal Management',
    compTargetManagement: 'Company Goal Management',
    scoringManagement: 'Evaluation Management',
    setSpecialGoals: 'set special goals',
    detail: 'detail',
    copyCategory: 'Copy category',
    copyEnterpriseObjectives: 'Copy enterprise objectives',
    targetDescription: 'Target description',
    specialPersonnelObjectives: 'Target of special approver',
    enterpriseObjectives: 'Enterprise objectives',
    targetSetting: 'Target setting',
    addIndicator: 'Add indicator',
    selectIndicators: 'Select Indicator',
    copySelfScheme: 'Duplicate my program',
    copyOthersScheme: "Replicate others' programs",
    schemesProportion: 'Percentage of programs',
    startDate: 'Start Date',
    endDate: 'End Date',
    target: 'Target',
    remarks: 'Remarks',
    copyAppraisalScheme: 'Copy the assessment program',
    currentYear: 'Current year',
    copyYear: 'Copy year',
    assessmentList: 'Appraisal List',
    setTarget: 'Set Up',
    targetSetting2: 'Target Setting',
    targetConfirm: 'Target Confirm',
    originalAssessmentScheme: 'Original assessment scheme',
    proportion: 'proportion',
    targetModificationDescription: 'Goal Modification Description',
    schemeModificationType: 'Program Modification Type',
    addScheme: 'Add a plan',
    targetModification: 'target modification',
    schemes: 'Program',
    assessmentCycle: 'Assessment Cycle',
    indicatorModificationType: 'Indicator modification type',
    applicationScope: 'Scope of application',
    saleAndMarketTargetSetting: 'Sales / Marketing category (target setting)',
    saleAndMarketTargetModify: 'Sales/Marketing category (target revision)',
    seniorManagementTarget: 'senior management target',
    yes: 'yes',
    no: 'no',
    maintainTarget: 'maintain target',
    modifyTarget: 'modify target',
    appraisalQuery: 'Appraisal Process & Results',
    resultQuery: 'Comprehensive Annual Results',
    see: 'View',
    baseInfo: 'Basic Information',
    targetProportion: 'Percentage of target',
    enterValue: 'Please enter a value',
    selectCombinationIndicator: 'Select Portfolio Indicator',
    indicatrix: 'indicatrix',
    explain: 'Description',
    printPreview: 'Print Preview',
    assessmentProcess: 'Appraisal Process',
    operator: 'Operator',
    operationTime: 'Operation time',
    historicalDocuments: 'History of documents',
    treatment: 'Processing records',
    handler: 'Handler',
    partTimeEndDate: 'Deputy post expiration date',
    weightDistribution: 'Weight distribution',
    weightProportion: 'Weight Proportion',
    adjustmentRemarks: 'Adjustment remarks',
    proportionSchemes: 'Percentage of programs',
    stiAchievementRate: 'STI Achievement rate',
    kpiAchievementRate: 'KPI achievement rate',
    stiAchievementRateOfCompany: 'STI Achievement rate of company',
    stiAchievementRateOfPerson: 'STI Achievement rate of person',
    adjustment: 'Adjustment',
    targetDetails: 'Target details',
    calculatedAccordingToActualSales: 'Calculated according to actual sales',
    processPreview: 'Process Preview',
    newEmployeesIDP: 'new employees PIP',
    staff: 'staff',
    copyInterviewRecords: 'Copy interview records',
    addInterviewRecords: 'Add interview records',
    copyFromTMC: 'copy from TMC',
    affirm: 'Confirm',
    historicalObjectives: 'historical objectives',
    actual: 'actual',
    achievementRate: 'achievement rate',
    comprehensiveAchievementRate: 'comprehensive achievement rate',
    unlock: 'unLock',
    applicableDepartment: 'Applicable Department',
    targetType: 'Target type',
    challengeGoal: 'Challenge goal',
    basicRequirements: 'Basic Requirements',
    addTarget: 'Add target',
    addTo: 'Add To',
    appraisalCycleSetting: 'Period / Target Setter Setting',
    isDefaultKPIFrequency: 'Default Appraisal Period',
    periodYear: 'year',
    newAppraisalCycle: 'New appraisal cycle',
    KPIAssessmentFrequency: 'KPI assessment Period',
    STIAssessmentFrequency: 'Sti Assessment Frequency',
    isSetGoalsForEmployees: 'Target Maker By Employees',
    directReports: 'Direct Reports',
    KPIAnnualScore: 'KPI annual score',
    abilityScore: 'Ability score',
    comprehensiveScore: 'Comprehensive score',
    annualComprehensiveEvaluation: 'Annual comprehensive evaluation',
    confirmResult: 'Confirm result',
    firstAssessmentLaborNo: 'First assessment labor No',
    firstAssessorSpecialist: 'First assessor specialist',
    secondAssessmentLaborNo: 'Second assessment labor No',
    HRJobNumber: 'HR job number',
    PersonInChargeOfTheCompany: 'Person Number in charge of the company',
    PersonInChargeOfTheCompany: 'Person in charge of the company',
    originalPersonnelType: 'Original personnel type',
    newPersonnelType: 'New personnel type',
    reserveBusinessLine: 'Do you want to keep the business line before unlocking',
    reserveConcurrentPost: 'Do you want to keep the part-time post before unlocking',
    setGoals: 'Target setting',
    departmentalObjectives: 'Departmental Goals',
    copyMyTarget: 'Copy My Target',
    copyOtherPeopleGoals: 'Copy Other People’S Goals',
    additionalNotes: 'Additional Notes',
    cycleSetting: 'Cycle setting',
    goalSetting: 'Goal setting',
    modify: 'Revision',
    retargeting: 'Reset',
    completionStatus: 'Input',
    determineResult: 'Determine result',
    resultConfirmation: 'Annual results confirmation',
    IDPCreation: 'PIP creation',
    modificationType: 'Modification type',
    modificationReason: 'Modification reason',
    role: 'role',
    personnel: 'personnel',
    approvalOpinions: 'Approval opinions',
    viewApprovalComments: 'View approval comments',
    start: 'Start',
    complete: 'Complete',
    executiveType: 'Executive type',
    scoreRules: 'Scoring Rules',
    modelTargetValue: 'STI sales target',
    organization: 'Organization',
    defaultKPIPeriod: 'Default cycle settings',
    KPIPeriodChangeNode: 'You are modifying the parent Settings. Modifying the parent Settings will overwrite the child Settings. Do you want to continue?',
    unannualKPIWeight: 'Non-annual KPI weights',
    annualKPIWeight: 'Annual KPI weights',
    weightConfig: 'weights Settings',
    deleteTips: 'Keep at least one piece of data',
    chooseTips: 'Check at least one piece of data',
    chooseOneTips: 'Only one data can be selected',
    alreadyExit: 'The current data already exists',
    weightDistributionConfig: 'Type Setting',
    date: 'Date',
    importFail: 'Import Fail',
    importSuccess: 'Import Success',
    importExcelTips: 'Please upload the correct Excel template',
    autoFillTips: 'Automatic Generate',
    executive: 'executives',
    weightDistributionCheckTips: 'required and 100 characters limit',
    notKpiWeight: 'Non-Annual KPI Weight',
    kpiWeight: 'Annual KPI Weight',
    STIWeight: 'STI Weight',
    WeightSetting: "Weight Setting",
    required: "Required",
    notMeetRequirements: "Required a Number in [0-100]",
    CurrentYearDataAlreadyExists: "Current Year Data Already Exists",// Current year data already exists
    keepAtLeastOne: 'Keep at Least One',// keep at least one
    AssessmentWeight: "Assessment Weight",
    administrative_and_business_required_100: "The sum of administrative lines and business lines is required to be 100",
    not_maintained: "not maintained",
    draft: "draft",
    imported: "imported",
    submitted: "submitted",
    Modification_to_be_submitted: "Modification to be submitted",
    target_confirmed: "target confirmed",
    maintained: "maintained",
    unlocked: "unlocked",
    aborted: "aborted",
    expired: "expired",
    instruction_template: "Instruction Template",
    January: "January",
    February: "February",
    March: "March",
    April: "April",
    May: "May",
    June: "June",
    July: "July",
    August: "August",
    September: "September",
    October: "October",
    November: "November",
    December: "December",
    applicable_personnel: "Applicable persons",
    manual_calculation: "Manual calculation",
    newExecutives: 'New executives',
    seniorExecutive: 'senior executive',
    english: 'english',
    chineseAndEnglish: 'chinese and english',
    combinedWeight: 'Total Weights',
    compositeAchievementRate: 'Composite Achievement Rate',
    targetNameCheckTips: 'Please enter the target name',
    targetProportionCheckTips: 'Please enter the target proportion',
    startDateCheckTips: 'Please select a start date',
    endDateCheckTips: 'Please select an end date',
    targetIdCheckTips: 'Please select a description template',
    appealDetails: 'Appeal Details',
    appealExplain: 'Appeal Explain',
    additionalPoints: 'Additional Scores',
    additionalPointsInstructions: 'Additional notes',
    additionalInstructions: 'Additional notes',
    gradingRule: 'Grading rule',
    score: 'Score',
    completeStatus: 'Completion',
    achievementRateAdditionalPoints: 'Additional STI Score',
    achievementRateAdditionalNotes: 'STI Additional Notes',
    indexAttachmentUpload: 'Index Attachment upload',
    set: 'Set Up',
    appeal: 'Appeal',
    upload: 'upload',
    appealTips: 'Please confirm within three working days. Failure to confirm within the time limit shall be deemed as confirmation. If you have any objection, please submit the amendment application after confirmation.',
    appealTips2: 'Please confirm your assessment objectives. If you have any objection, you need to amend it within 10 working days. If you fail to do so after the deadline, it will be regarded as confirmation.',
    appealTips3: 'Please confirm your assessment results. Exceeding three working days will be considered as confirmation.',
    appealTips4: 'Please confirm your assessment Result. If you have any objection, you need to amend it within 10 working days. If you fail to do so after the deadline, it will be regarded as confirmation.',
    appealTips5: 'Please confirm your assessment result. If it is not confirmed within three working days, the system will automatically confirm it.',
    dbAppeal: 'Second Appeal',
    actualCompleteRate: 'Actual Completion Rate',
    firstAppealScore: 'First Appeal Score',
    secondAppealScore: 'Second Appeal Score',
    theOriginalKPIScore: 'Original KPI Score',
    origin: 'Original',
    end: 'End',
    appealAttachment: 'Appeal Attachment',
    investigate: 'Investigation',
    suggestedSolutions: 'Suggested Solutions',
    appealType: 'Operation Type',
    maintainOriginalState: 'Maintain original result',
    modifyTheResults: 'Modify the results',
    dateTips1: 'The start date cannot be later than the end date',
    dateTips2: 'The end date cannot be less than the start date',
    indexWeight: 'Index weight',
    targetCannotBeEmpty: 'Target cannot be empty',
    originalTarget: 'Original target',
    newTarget: 'New target',
    logout: 'Logout',
    downloadSuccessful: 'Download successful',
    downloadFailed: 'Download failed',
    selectAtLeastOnePiece: 'Select at least one piece of data',
    stiDesc: 'Based on actual company sales',
    indexUnit: 'Index unit',
    tipDesc100: 'The sum of index weights in each scheme should be equal to 100',
    copySuccessful: 'Copy successful',
    copyFail: 'copy fail',
    selectAData: 'Please select a piece of data',
    printPreviewFailed: 'Print preview failed',
    KPIAssessmentFrequencyCheckTips: 'Please enter KPI assessment frequency',
    setByEmployeeCheckTips: 'Please select whether the target is set by the employee',
    appraisalCyclePersonCheckTips: 'Please select the person to set the appraisal cycle first',
    appraisalFrequencySetCheckTips: 'If the default appraisal frequency is set or not set, batch operation cannot be performed',
    setSeparatelyCheckTips: 'It is the person transferred after October and needs to be set separately',
    yearCheckTips: 'Year cannot be blank',
    departmentCheckTips: 'Department cannot be empty',
    targetNameValueCheckTips: 'Target name cannot be empty',
    departmentTargetEmptyTips: 'Department target has not been set yet',
    copyYearCheckTips: 'Please select a copy year',
    copyTargetCheckTips: 'Please select a copy target',
    appraisalTargetCheckTips: 'Please select appraisal target',
    modelCheckTips: 'The model is inconsistent and cannot be copied',
    copyTargetEmptyTips: 'The copied target indicator is empty and cannot be copied',
    result: 'Result',
    startTime: 'Start Time',
    endTime: 'End Time',
    employeeID: 'Empl ID',
    departmentID: 'Department ID',
    employeeRecords: 'Employee Record',
    jobClassification: 'Job classification',
    weightOfMainAndAuxiliaryPosts: 'Main and vice post weighting',
    transactionDate: 'Date of change',
    assessId: 'Appraisal ID',
    operationReason: 'operation reason',
    salaryTypeChange: 'salary type change',
    salaryChangeDate: 'Salary Variation Date',
    originalEmployeeLevel: 'Original employee level',
    originalSalaryCategory: 'Original Salary Category',
    MainOrAuxiliaryPost: 'Primary Job / Secondary Job',
    treatmentRecord: 'treatment condition',
    approverType: 'approver Type',
    addIndicatorGroup: 'add Indicator Group',
    indicatorGroup: 'Indicator Group',
    notFilledIn: 'Not filled in',
    secondaryConfirm: 'Are you sure to submit?',
    approveTime: 'approve time',
    secondaryConfirmDelete: 'Are you sure to delete?',
    selectedPerson: 'selected person',
    selectPerson: 'Select person',
    pleaseComplete: 'Please complete',
    weightLessThan100: 'The sum weight should be less than 100',
    preview: 'Preview',
    objectDescOrActionPlan: 'Target Description/Action Plan',
    approvalNode: 'Approval Node',
    approver: 'Approver',
    approvalDate: 'Approval Date',
    oaProcessNo: 'OA Process No',
    todo: 'My To Do',
    done: 'My Completed Tasks',
    commonLinks: 'Commonly Links',
    more: 'more',
    personinfo: 'Individual Data',
    lv: 'Grade',
    commonLinks: 'Common Links',
    myAppraise: 'My Appraise',
    teamAppraise: 'Team Appraise',
    number: 'Empl ID',
    name: 'Name',
    level: 'Grade',
    staffLevel: 'Grade',
    department: 'Department',
    position: 'Position',
    return: 'return',
    model: 'Model',
    zh: 'Simplified description',
    czh: 'Traditional description',
    en: 'English description',
    setSalesSTITarget: 'Set sales STI target',
    detailed: 'Detailed',
    new: 'New',
    yearBonusTemp: 'Year end bonus template',
    businessUnits: 'Business unit',
    onthespot: 'Place of signing',
    requiredItemsCheckTips: 'Required items cannot be blank (marked in red)',
    linkAddress: 'Url',
    oaApprovalNo: 'OA Approval No',
    scoreManagement: 'score Management',
    AppraisalQuery: 'Appraisal Inquiry',
    AppraisalQuery1: 'Appraisal Inquiry - function',
    AppraisalQuery2: 'Appraisal Inquiry - Sales / market',
    AppraisalQuery3: 'Appraisal Inquiry - Senior Management',
    notEqual100: 'The sum of weights is not 100',
    empScoreConfirmTips: 'Please confirm your assessment results. If you have any objection, you need to put forward amendment within 10 working days. If you fail to put forward it within the time limit, it will be deemed as confirmation.',
    secondAppraiserOnlyOne: 'Only one level 2 appraiser can be selected',
    setValueError: 'Please Set Up the Index Model',
    errFileType: 'Error File Type',
    maxFileSizeError: 'File Size Can not exceed',
    sameFileError: 'Cannot upload files with the same name',
    maxFileNameError: 'The file name cannot contain more than 80 characters',
    errFileSapce: 'Invalid file name',
    selectDialog: 'Select',
    weightOfAbilityAssment: 'Weight of Ability Assessment',
    noPermission: 'No Permission',
    modelSortCheckTips: 'The index model value shall be ascending and descending sequence (when the calculation method is interval)',
    modelSortCheckTips2: `s' index model value should be in ascending or descending order (when the calculation method is "conversion by interval" or "one-to-one correspondence by interval")`,
    weightCheckTips: 'Weight cannot be empty',
    indexNameCheckTips: 'Indicator name cannot be empty',
    indexDescCheckTips: 'Indicator description cannot be empty',
    objectDescOrActionPlanTips: 'Objective description / action plan cannot be empty',
    dataSourceCheckTips: 'Data source cannot be empty',
    indicatorModelCheckTips: 'Indicator model cannot be empty',
    unitCheckTips: 'Unit cannot be empty',
    computeMethodCheckTips: 'Calculation method cannot be empty',
    totalWeightCheckTips: 'The total weight is not 100%',
    kpiTotalWeightCheckTips: 'The total weight of KPI is not 100%',
    stiTotalWeightCheckTips: 'The total weight of STI is not 100%',
    rolePermPath: 'Data permission access path',
    putAway: 'put away',
    open: 'open',
    richEditorPlaceHolder: 'Please enter the text',
    uploadFile: 'Upload Files',
    AppraisalYear: 'Appraisal Year',
    AppraisalType: 'Appraisal Type',
    goalSetter: 'Goal setter',
    companyError: 'The enterprise indicator standard model of this year has not been obtained. Please configure the enterprise indicator standard model',
    allOption: 'Please Select',
    ScoringCriteria: 'Scoring Criteria',
    level5: 'outstanding -- completed challenge objectives',
    level4: 'exceed expectations -- fail to meet challenge objectives but exceed basic objectives',
    level3: 'qualified -- met basic objective requirements',
    level2: 'partially qualified -- results are between basic and lower targets and still need improvement',
    level1: 'Failed -- result below target lower limit',
    levelRemark: 'Note: Scoring can retain one decimal point after the decimal point, such as 3.5, 4.1; Scores are rounded to two decimal places',
    objective: 'Objective',
    percentageOfTarget: 'Percentage of target',
    selectIndicator: 'Select Indicator',
    selectPortfolioIndicator: 'Select Portfolio Indicator',
    indicator: 'Indicator',
    description2: 'Description',
    pleaseEnter: 'Please enter',
    indicatorName: 'Indicator Name',
    portfolioIndicatorName: 'Portfolio Indicator Name',
    confirmOk: 'OK',
    timeoutErr: 'The request has no response or timed out. Please try again later',
    permissionErr: 'You do not have the permission for this function, and some data fails to be obtained',
    logErr: 'Your login credentials have expired and you are about to log in again',
    versionErr: 'Please wait while version is being updated',
    assessorType: 'Assessor Type',
    annualGroup: 'annual group',
    createUser: 'Create User',
    distributionManage: 'Distribution Manage',
    approverConfig: 'Approver Config',
    DepartHeadSetting: 'Depart Head Config',
    duration: 'Duration',
    primaryArchitecture: 'Primary architecture',
    secondaryArchitecture: 'Secondary architecture',
    tertiaryArchitecture: 'Tertiary architecture',
    quaternaryArchitecture: 'Quaternary architecture',
    fifthArchitecture: 'Fifth architecture',
    sixthArchitecture: 'Sixth architecture',
    seventhArchitecture: 'Seventh architecture',
    indexNumber: 'Index number',
    completionRate: 'Completion rate',
    isAnnualIndicator: 'Is annual indicator',
    salesRevenueCompany: 'Sales revenue - company',
    profitCompany: 'Profit - company',
    salesRevenueIndividual: 'Sales revenue - individual',
    profitIndividual: 'Profit - individual',
    indicatorSetting: 'Indicator Setting',
    executiveList: 'Maintenance of executive List',
    executiveTarget: 'Executive objective statement configuration',
    assessmentInformationMaintenance: 'Employee Information Maintenance',
    assessmentInformationInquiry: 'Employee Appraisal inquiry',
    salesTargetConfirmation: 'Sales target confirmation',
    functionalProcess: 'Function score',
    functionalAppeal: 'Functions of the appeal',
    functionAddition: 'Functional subdivision',
    functionalTarget: 'Functional goals',
    saleTargetReport: 'Sales market kpi/sti target',
    salesKPIScoreReport: 'KPI score of sales market',
    salesSTIReport: 'Sales market STI summary',
    functionalAssessmentReport: 'Functional performance appraisal schedule',
    employeeStatus: 'Employee status',
    includedInSTI: 'Included in STI',
    KPIScore: 'KPI score',
    colNotFilled: 'Fill in at least one model value',
    functionPermissionCheckTips: 'No permission to use this function',
    currentApprover: 'Current Approver',
    setBonusCap: 'Set bonus cap',
    compEval: 'Comprehensive assessment settings',
    rankingSettings: 'Ranking settings',
    summaryAssessmentReport: 'Summary assessment report',
    deptLevel: 'Hierarchy',
    unlockDate: 'Unlock time',
    operatingUser: 'Operating user',
    history: 'History',
    appraisalResultTemplate: 'Appraisal result template',
    bonusCap: 'Bonus cap',
    automaticallyBroughtOutAndModifiable: 'Automatically brought out and modifiable',
    LevelID: 'Level ID',
    proportion2: 'proportion',
    sortNumber: 'Sort number',
    collectionLevel: 'Collection level',
    roundingRule: 'Rounding rule',
    excellent: 'excellent',
    excellentAndGood: 'Excellent + good',
    partiallyQualified: 'Partially qualified',
    yearCheckTips2: 'Please select a year',
    deptCheckTips: 'Please select a department',
    annualGroupCheckTips: 'Please enter the annual organization',
    PersonInChargeOfTheCompanyCheckTips: 'Please select the person in charge of the company',
    addAnnualOrganization: 'Add annual organization',
    editAnnualOrganization: 'Edit annual organization',
    ruleDescription: 'Rule description',
    forcedDistributionRule: 'Forced distribution rule',
    rankingModel: 'Ranking model',
    ruleDescriptionCheckTips: 'Please enter a rule description',
    addForcedDistributionRule: 'Add forced distribution rule',
    editForcedDistributionRule: 'Edit forced distribution rule',
    forcedDistributionRuleDetail: 'Forced distribution rule details',
    requiredCannotBeBlank: 'Required (*) cannot be blank',
    rankingModelSortCheckTips: 'Ranking model sorting number cannot be duplicate',
    rankingModelProportionCheckTips: 'The sum of ranking model proportion is not 100%',
    appraisalOrganization: 'Appraisal organization',
    participationInForcedDistribution: 'Participation in forced distribution',
    departmentHead: 'Department head',
    annualOrganizationSettings: 'Annual organization settings',
    appraiseeSettings: 'Appraisee settings',
    psBonusCap: 'PS bonus cap',
    performanceBonusCap: 'Performance bonus cap',
    performanceBonusCapEdit: 'Performance bonus cap edit',
    bonusLimitCheckTips: 'Please enter the bonus limit',
    automaticCalculation: 'Automatic calculation',
    calculationFailed: 'Calculation failed',
    maintenanceResults: 'Maintenance results',
    reach: 'reach',
    total: 'total',
    finalAchievementRate: 'Final achievement rate',
    adjustmentRemarksCheckTips: 'Please enter adjustment remarks',
    developmentPlanReport: 'Personal development report',
    employmentType: 'Employment type',
    salesUnlock: 'Sales unlock',
    targetUnlock: 'Target unlock',
    evaluationUnlock: 'Evaluation unlock',
    gradeSimplified: 'Grade (Simplified)',
    gradeTraditional: 'Grade (Traditional)',
    gradeEnglish: 'Grade (English)',
    fiveLevelDept: "five-level department",
    deptlead: "Whether to include department heads",
    category1: "category",
    staffID: "staffID",
    computePerson: "Calculator",
    computeTime: "calculating time",
    compute: "calculate",
    individualSTIAchievementRate: "Individual STI achievement rate",
    companySTIAchievementRate: "STI achievement rate of the company",
    totalSTIAchievementRate: "Total STI achievement rate",
    salesSTIScoreReport: "Sales market STI score",
    firstHalfYear: "First half year",
    secondHalfYear: "Second half year",
    weightAchievementRate: "Weight achievement rate",
    totalWeightCompany: "Total weight - company",
    totalWeightIndividual: "Total weight - individual",
    salesResultsSummaryReport: "Summary of sales market kpi/sti results",
    performanceInterview: "Performance interview",
    itemsToBeDeveloped: "Items to be developed",
    interviewRecord: "Interview record",
    helper: "helper",
    speedOfProgress: "speed of progress",
    actualCompletionTime: "Actual completion time",
    progressComments: "Progress comments",
    cancellationReason: "Cancellation reason",
    actionPlan: "Action plan",
    plannedCompletionTime: "Completion Date",
    actionDescription: "Action description",
    outputResults: "Output results",
    interviewTime: "Interview time",
    functionSalesSTISummaryReport: "Function / sales market STI summary",
    //汇总得分
    aggregateCalculation: "Aggregate calculation",
    year1: "year",
    yearOrganization: "Organization of the Year",
    fiveDept: "five-level department",
    deptHeads: "Whether to include department heads",
    employeeID1: "employee ID",
    compute1: "calculate",
    //kpi汇总确认
    specialData: "special assessment(double track, main and auxiliary posts, job transfer)",
    search1: "Inquire",
    confirmScore: "confirm score",
    export1: "export",
    PersonID: "Person ID",
    department1: "department",
    KPIScore1: "KPI score",
    operate: "operate",
    checkDetails: "check the details",
    Details: "Details",
    personType1: "Person Type",
    assessmentMethod: "Assessment method",
    jobCategory: "Job classification",
    macPost: "Primary / secondary post",
    assessmentID: "Assessment ID",
    programme: "Program achievement rate",
    startingTime: "Starting time",
    endTime1: "End Time",
    assessmentCycle: "Assessment cycle",
    macPostWeight: "Weight of primary and secondary posts%",
    doubleWeight: "Dual Line Weights%",
    doubleWeight2: "Dual Line Weights",
    TIWeight: "Index weight%",
    TPWeightScheme: "Proportion of schemes%",
    KPIScore2: "KPI ",
    timeRatio: "time ratio",
    WAScore: "Weighted Average Score",
    PARate: "Program achievement rate%",
    GARate: "goal achievement rate%",
    //sti汇总得分
    TARate: "STI total achievement rate%",
    ISARate: "Individual STI Achievement Rate",
    ESARate: "STI achievement rate of the company",
    FARate: "final achievement rate",
    WAARate: "Weighted Average Achievement Rate",
    interviewIdp: "Interview Record",
    competencyAppraisalResults: "Competency Appraisal Results",
    stiTotalAchievementRate: "STI Total Achievement Rate",
    annualKPIAchievementRate: "Annual KPI Achievement Rate",
    annualKPI: "Annual KPI",
    abilityAssessment: "Ability Assessment",
    annualComprehensiveScore: "Annual Comprehensive Score",
    annualComprehensiveGrade: "Annual Comprehensive Grade",
    thInterview: "th interview",
    section: "",
    recorder: "Recorder",
    individualDevelopmentPlan: "Development Plan (Optional)",
    toBeDevelopedGoal: "To Be Developed Goal",
    developmentGoals: "development Goals",
    completionDescription: "Completion description",
    uploadAttachments: "Upload attachments",
    actionPlanDescription: "Action Plan Description",
    cancellationReasonCheckTips: "Please enter cancellation reason",
    actualCompletionTimeCheckTips: "Please select the completion time",
    hrTodo: "HR To Do",
    employeeInformationToBeMaintained: "Employee information to be maintained",
    targetToFollow: "Target to follow",
    evaluationToBeFollowedUp: "Evaluation to be followed up",
    complaintToBeFollowedUp: "Complaint to be followed up",
    comprehensiveEvaluationToBeReviewed: "Comprehensive evaluation to be reviewed",
    interviewIDPNotStarted: "Interview & PIP not started",
    myTeam: "My Team",
    annualComprehensiveAssessmentScoresAndGrades: "Annual comprehensive assessment scores and grades",
    companyTargetExportReport: "Company performance score report",
    functionalPerformanceTargetImport: "Functional Performance Target Import",
    todo2: "Todo",
    submitted2: "Submitted",
    KPICompute: "KPI Compute",
    STICompute: "STI Compute",
    CACompute: "Capacity assessment calculation",
    CCCompute: "Calculation of comprehensive results",
    notSubmitted: "Not submitted",
    calculationItems: "Calculation items",
    confirmCalculationResults: "Confirm calculation results",
    annualKPIAchievementRate: "Annual KPI achievement rate",
    annualComprehensiveScore: "Annual comprehensive score",
    KPIAchievementRate: "KPI achievement rate%",
    TotalKPIAchievementRate: "Total KPI achievement rate%",
    TotalKPIAchievementRate2: "Total KPI achievement rate",
    assessmentType: "Assessment type",
    WAARate: "Weighted average achievement rate",
    capacityCategory: "Capacity category",
    score1: "score",
    weight1: "weight",
    DLAweight: "Double line assessment weight",
    PleaseSelectAnnualOrganization: "Please select annual organization",
    PleaseSelect: "Please select the option box with star before calculating",
    PleaseSelect1: "Please select the option box with star before querying",
    submissionTime: "Submission time",
    actualCheckTips: "The actual value of the indicator cannot be empty",
    functionAppraisalCycleMaintenance: "Function appraisal cycle maintenance",
    assessTypeCheckTips: "Only single assessment type objectives can be submitted in batch",
    executivePerformanceSummary: "Executive performance summary",
    englishName: "English  name",
    chinahName: "China name",
    countryOfContract: "Country of contract",
    bonusProportion: "STI%",
    targets: "Targets (Set Individual target plan)",
    stiSpread: "STI spread",
    totalAchieved: "Total achieved",
    specificationOfTarget: "Specification of target (if needed)",
    achievingRateCompanyCheckTips: "Company achievement rate is empty",
    itemTypeCheckTips: "Please select the item to be developed",
    progressCheckTips: "Please select progress",
    planTypeCheckTips: "Please select an action plan",
    planContentCheckTips: "Please enter the plan content",
    outputResultCheckTips: "Please input output results",
    evaluationType: 'Evaluation type',
    TMCScore: "TMC score",
    scoreAfterModification: "Score after modification",
    LastUpdatedBy: "Last updated by",
    updateTime: "Update time",
    abilityResults: "Ability Results",
    rank: "rank",
    Check: "Check",
    performanceLevel: "Performance level",
    originalGrade: "Original grade",
    suggestionsFromSuperiors: "Suggestions from superiors",
    departmentRecommendations: "Department recommendations",
    forcedDistribution: "Forced distribution",
    finalGrade: "Final grade",
    reject: "reject",
    KPIAssessment: "KPI assessment(50%)",
    comprehensiveCapacity: "Comprehensive capacity (50%)",
    originalGrade1: "Original grade",
    recommendationLevel: "Recommendation level",
    ratingLevel: "Rating level",
    confirmRanking: "Confirm ranking",
    synchronizeTMCResults: "Synchronize TMC results",
    employeeTitle: "Employee title",
    raterID: "Rater ID",
    rater: "Rater",
    scoringTime: "Scoring time",
    obtain: "obtain",
    unlockSuccess: "Unlock success",
    unlockTips: "After unlocking, HR can directly modify the results without going through the appeal approval process",
    unlockTips2: "After unlocking, HR can modify the target directly without going through the target modification approval process",
    unlockPartTips1: "Confirm to unlock",
    unlockPartTips2: "'s assessment",
    unlockPartTips3: "'s target",
    excellent2: 'Excellent',
    good: 'Good',
    qualified: 'Qualified',
    unqualified: 'Unqualified',
    rankingQuery: 'Ranking query',
    resultQuery2: 'Result query',
    interviewIdpInquiry: 'Interview Record',
    viewAttachments: 'View attachments',
    departmentName: 'Department name',
    employeesInvolvedInAssessment: 'Employees involved in assessment',
    updatedBy: 'Updated by',
    includingIndividualSTIAchievement: 'Including: STI achievement rate of functional individuals',
    copyTMCDevelopItem: 'Copy TMC items to be developed',
    summaryStatus: 'Summary status',
    comprehensiveSummary: 'Comprehensive summary',
    rankingStatus: 'Ranking status',
    rating: 'Rating',
    rankingOfDepartmentHeads: 'Ranking of department heads',
    rankingOfCompanyPrincipals: 'Ranking of company principals',
    employeeConfirmation: 'Employee confirmation',
    leadershipScore: 'Leadership score',
    leadershipPillar: 'Leadership pillar',
    leadershipDescription: 'Leadership description',
    abilityEvaluation: 'Ability evaluation',
    secondaryConfirmReject:'Confirm rejection',
    cancelReject:'Cancel rejection',
    tmcCapabilityAssessmentModification:'TMC capability evaluation modification',
    tmcScoreEdit:'TMC score edit',
    tmcScoreDetail:'TMC score detail',
    summaryScore:'Summary score',
    summaryCalUnlock:'Summary calculation unlock(IT)',
    rateListDetail:'Rating details',
    deptRank5:'Ranking of five level departments',
    deptRank5Detail:'Ranking of five level departments-Detail',
    companyChargeRankDetail:'Ranking of company principals-Detail',
    actualsuggestions:'Actual|Suggestions',
    selectAssessmentMethod:'Please select the assessment method',
    weightSumConfirm:'The sum of weights must be 100 ',
    grade:'Grade',
    tmcWeightSetInfo:'Note: please maintain the evaluation method of each ability score of the employee (administrative line / business line / no score), and maintain the weight. The sum of the weights of administrative lines should be equal to 100%, and the weights of business lines should not be maintained separately.',
    change: 'Change',
    urge: 'Urge',
    completed: 'Completed',
    inProgress: 'In progress',
    notStarted: 'Not started',
    statusStatisticsOfDevItem: 'Development Item Status',
    interviewIDPCheckTips: 'Interview in completed status &pip cannot be urged',
    forcedDistributionLevel: 'Forced distribution level',
    FARatePercent:"final achievement rate%",
    totalAchievedPercent:"Total achieved%",
    tmcSyncInfo:'View synchronization progress',
    viewImportProgress: 'View import progress',
    tmcSyncMessage:'The synchronization request has been submitted. Please go to the "view synchronization results" button to view the results',
    distributionStandard:'Compulsory distribution standard',
    allowDistributionStandard:'Meet the standard',
    inconformityDistributionStandard:'Higher than the upper limit of forced distribution or lower than the lower limit of forced distribution',
    saveConfirm:'There is unsaved content on the page, do you want to save it',
    noSave:'Do not save',
    cancelSave:'Cancel saving',
    inconformityDistributionStandardTips:'There are still data that do not meet the mandatory distribution requirements and cannot submit scores',
    employee:'Employee',
    good2:'good',
    refresh:'refresh',
    deptlead2: "Including department heads",
    comprehensive:"Comprehensive",
    personSelect:"Currently selected",
    person:"persons",
    search2:"search",
    secondConfirmationScorePrompt: 'Please confirm again whether it is the final score? The system only provides one chance to modify the score. Once confirmed, it cannot be modified again.',
    suggeestionsNumber:'Number of suggestions',
    actualNumber:'Actual number',
    directReportsDistribution:'Forced distribution of direct reports',
    deptDistribution:'Department forced distribution',
    companyDistribution:'Mandatory distribution of the company',
    comprehensiveCalculation:"Calculation of comprehensive evaluation results",
    directReportsDistributionDetail:'Forced distribution of direct reports-Detail',
    deptDistributionDetail:'Department forced distribution-Detail',
    companyDistributionDetail:'Mandatory distribution of the company-Detail',
    forcedDistribution: "Forced distribution-Detail",
    comprehensiveResults:'Comprehensive results',
    myPerformanceTodo: 'My performance - to do',
    myPerformanceQuery: 'My performance - performance query',
    viewFunctionAppraisalObjectives: 'View function appraisal objectives',
    revisionOfFunctionalAssessmentObjectives: 'Revision of functional assessment objectives',
    functionalAssessmentObjectiveSetting: 'Functional assessment objective setting',
    confirmationOfFunctionalAssessmentObjectives: 'Confirmation of functional assessment objectives',
    functionalAssessment: 'Functional assessment',
    salesAndMarketAssessment: 'Sales / Market Assessment',
    seniorManagementAssessment: 'Senior management assessment',
    interviewAndIDPMaintenance: 'Interview & PIP maintenance',
    interviewAndIDPDetails: 'Interview & PIP details',
    teamPerformanceTodo: 'Team performance - to do',
    teamPerformanceQuery: 'Team performance - performance query',
    departmentObjectiveMaintenance: 'Department objective maintenance',
    departmentObjectiveDetails: 'Department objective details',
    unlockAppraisalInformation: 'Unlock appraisal information',
    salesAndMarketAssessmentObjectives: 'Sales / market assessment objectives',
    executiveAssessmentObjectives: 'Executive assessment objectives',
    groupYearConfirmationPrompt: 'This annual group has updated the included department information. If you confirm to edit, all the enforced distribution data of this annual group will be cleared. Are you sure you want to confirm to edit?',
    personalPlanEmpty:'Personal development plan cannot be empty',
    noInterviewRecord:'No interview record',
    IDPnoStart:'Development Plan-Not Started',
    IDPprogress:'Development Plan-In Progress',
    stateError:'Status acquisition failed',
    manuallySelected:'Items to be developed have been manually selected and cannot be copied from TMC system',
    correctionNotFilled:'Correction score not filled',
    helperTips:'Please enter a helper',
    developmentGoalsTips:'Please enter the development goal',
    completionDescriptionTips:'Please enter the completion description',
    batchCalculationOfSTI:'Batch calculation of STI achievement rate',
    STIDetail:'STI detail',
    DevelopmentPlanStatus:'Development Plan Status',
    DevelopmentPlanStatusOption:'Development Plan (Optional)',
    planNumber: 'Plan Number',
    pip: 'Performance Improvement Plan',
    planStatus: 'Plan Status',
    trackStatus: 'Track Status',
    planUrge: 'Urge Plan',
    trackUrge: 'Urge Tracking',
    submitTime:'Submission date',
    submitTimeTips:'Please select the date of submission',
    PeriodicityNotEstablished:'Periodicity not established',
    pipNumber: 'Plan Number',
    emplId: 'Employee ID',
    planFormulationDate: 'Plan Date',
    withoutPerformanceImprovementPlan: 'Without Performance Improvement Plan',
    print: 'Print',
    selectAll: 'Select All',
    printSelection: 'Print Selection',
    action: 'Action',
    indexNum: 'No.',
    trackingRecords: 'Tracking Record',
    pipMethod: 'Areas for Improvement in Performance (to be as detailed as possible and give examples)',
    pipContent: 'What are the expected performance (list measurement where possible)',
    pipMeasure: 'Action Plan',
    trackingResult: 'Actual Performance Result based on the action plan',
    trackingAction: 'Follow-up actions',
    uploadSupportFiles: 'Upload supporting documents',
    quit: 'Quit',
    performanceTrackingRecords: 'Performance tracking records',
    pieceRate: "Piece rate",
    function: "Function",
    sales: "Sales",
    market: "Market",
    newEntry:'Newly hired',
    resignation:'Resignation',
    retire:'retire',
    transferjob:'Job changes',
    endOfPartTimeJob:'End of part-time job',
    otherChanges:'Other changes',
    salaryCategoryConversion:'Salary category conversion',
    degradation: 'Degradation',
    resignation: 'Resignation',
    retirement: 'Retirement',
    termination: 'Termination',
    otherChanges: 'Other Changes',
    hire: 'Hire',
    transfer: 'Transfer',
    rehire: 'Rehire',
    promotion: 'Promotion',
    addAssistant: 'Add Assistant',
    invalidAssistant: 'Invalid Assistant',
    retireReturn: 'Retire Return',
    payChange: 'Pay Change',

    contractWorker: 'Permanent',
    laborWorker: '劳务工',
    laborDispatchPersonnel: '劳务派遣人员',
    earlyRetiree: 'Early Retiree',
    intern: 'Internship',
    hourlyWorker: 'Hourly Worker',
    socialWorker: '社工',
    contract: 'Contract',
    temporary: 'Temporary',
    laborDispatchPersonnelB: '劳务派遣人员B',
    recorder: 'Recorder',
    printSelection: 'Print Selection',
    cancelCalculationResults: "Cancellation of confirmation results",
    urgeSuccess: 'Urged Successfully',
    urgeFail: 'Urgency Failed',
    yearFormatError: 'Please select the year',
    No1: '1st Tracking Record',
    No2: '2nd Tracking Record',
    No3: '3rd Tracking Record',
    No4: '4th Tracking Record',
    No5: '5th Tracking Record',
    No6: '6th Tracking Record',
    No7: '7th Tracking Record',
    No8: '8th Tracking Record',
    No9: '9th Tracking Record',
    No10: '10th Tracking Record',
    loading: 'Loading',
    pipTips:'The employee has not submitted his employee information. Please contact HR for assistance.',
    adjustmentValue:'adjustment value',

}

export default en